export const getTopPaddingFromAspectRatio = (aspectRatio?: number) => {
    // return aspectRatio ? `${((heightRatio as number) / (widthRatio as number)) * 100}%` : 0;
    return  aspectRatio ? `${1/aspectRatio*100}%` : 0;
  }